import React, { Component } from "react";
import style from "./MediclaimResponse.module.css";
import moment from "moment";
import { Collapse } from "reactstrap";
import { formatNumberToCurrency } from "../../../../utils/CommonUtil";


function dateFormatter(cell) {
    if (!cell) {
        return "";
    }
    return `${
        moment(cell).format("YYYY-MM-DD")
            ? moment(cell).format("YYYY-MM-DD")
            : moment(cell).format("YYYY-MM-DD")
        }`;
}

export class LineItemResponseSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    checkData = (data) => {
        if (!data) {
            return "Not Available";
        }
        return data;
    }

    // openDrugRecord = () => {
    //     this.setState({
    //         isDrugRecordOpen: !this.state.isDrugRecordOpen
    //     })
    // }

    checkResposneData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.response_code + " " + item.response_description}
                    </p>
                ))
                )}
            </div>
        );
    }

    // checkFailureResponseData = (data) => {
    //     if (!data || (data && JSON.parse(data).length === 0)) {
    //         return "Not Available";
    //     }

    //     let response = JSON.parse(data);
    //     return (
    //         <div>
    //             {(response && response.map((item, index) => (
    //                 <p className="mb-0">
    //                     {item.message}
    //                 </p>
    //             ))
    //             )}
    //         </div>
    //     );
    // }

    checkGeneralCommentsData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.comment}
                    </p>
                ))
                )}
            </div>
        );

    }

    checkDrugRecord = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div className="col-md-12 mt-2">
                {(response && response.map((item, index) => (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>DUR Item No. </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.dur_item_no)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>DUR Security Indicator </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.dur_scecurity_indicator)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>DUR Add Info. Indicator </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.dur_add_infor_indicator)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Drug Conflict Code </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.drug_conflict_code)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Previous Date of Fill </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.previous_date_of_fill)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Quantity (Previous Fill) </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.quantity_of_previous_prefill)}
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Other Prescriber Indicator </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.other_Prescriber_Indicator)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Comments 1</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.comments1)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Comments 2</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.comments2)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Comments 3</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.comments3)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Database Indicator</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.database_indicator)}
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Other Pharmacy </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.otherPharmacy)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </React.Fragment>
                ))
                )}
            </div>

        );
    }

    checkResposneData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.response_code + " " + item.response_description}
                    </p>
                ))
                )}
            </div>
        );
    }

    // toggle a modal
    toggle = (val) => {
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen,
        }));
    }

    checkFailureResponseData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);
        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.message}
                    </p>
                ))
                )}
            </div>
        );
    }

    checkGeneralCommentsData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.comment}
                    </p>
                ))
                )}
            </div>
        );

    }

    /**
* This method will be called to format the table data for valid data.
* @param {string} data of the table column.
* @returns {string} data with first letter capital or Not available string
*/
    detailFormatter = (data) => {
        if (!data) {
            return "NA";
        } else {
            return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
        }
    }

    /**
     * This method will be called to format the table data for valid data.
     * @param {string} data of the table column.
     * @returns {string} data or Not available string
     */
    checkValidData = (data) => {
        if (!data) {
            return "NA";
        } else {
            return data;
        }
    }

    checkValidPrice = (data) => {
        if (data || data === 0) {
            return data;
        } else {
            return "NA";
        }
    }

    doctorNameFormat = (cell, surname) => {
        if (!cell) {
            return "NA";
        } else {
            return ((cell ? (cell.charAt(0).toUpperCase() + cell.slice(1)) : "") + " " +
                (surname ? (surname.charAt(0).toUpperCase() + surname.slice(1)) : ""))
        }
    }

    render() {
        let data = this.props.data;
        return (
            <div class="claim-response-body">
                <div class="claim-response-row d-flex align-items-center justify-content-between">
                    <div class="claim-response-col line-col"><span>{this.detailFormatter(data.line_type)}</span></div>
                    <div class="claim-response-col tariff-col"><span>{this.checkValidData(data.tariff_code)}</span></div>
                    <div class="claim-response-col nappi-col"><span>{this.checkValidData(data.nappi_code)}</span></div>
                    <div class="claim-response-col desc-col"><span>{this.checkValidData(data.description)}</span></div>
                    {/* <div class="claim-response-col dia-col"><span>I51.6; R50.9; E11.5;</span></div> */}
                    <div class="claim-response-col name-col"><span>{this.doctorNameFormat(data.name, data.surname)}</span></div>
                    <div class="claim-response-col quantity-col"><span>{this.checkValidData(data.quantity)}</span></div>
                    <div class="claim-response-col price-col"><span>{formatNumberToCurrency(data.price)}</span></div>
                    <div class="claim-response-col status-col"><span>{this.checkValidData(data.status)}</span></div>
                    {/* <div class="claim-response-col del-indicator-col"><span>Rejected</span></div> */}
                   {data.isClaimed === 1 && ( <div class="claim-response-col action-col collapse-trigger justify-content-center d-flex" onClick={this.toggle}>
                    {this.state.isOpen ? (
                        <i className="fa fa-angle-up" aria-hidden="true"></i>
                        ) : (
                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                        )}
                    </div>)}
                    {data.isClaimed === 0 && ( 
                    <div class="claim-response-col action-col collapse-trigger justify-content-center d-flex">
                    </div>)}
                </div>
                <Collapse isOpen={this.state.isOpen}>
                    <div>
                            <div class="d-flex claim-collapse-row response-record">
                                <div class="claim-response-col response-record-col d-flex align-items-start">
                                    Response Record :
                                </div>
                                <div class="claim-response-col flex-grow-1 d-flex ">
                                    <span>{this.checkResposneData(data.response_record)}
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex claim-collapse-row general-comments">
                                <div class="claim-response-col general-comments-col d-flex align-items-start">
                                    General Comments :
                                </div>
                                <div class="claim-response-col flex-grow-1 d-flex flex-column">
                                    <span>{this.checkGeneralCommentsData(data.general_comment)}
                                    </span>
                                </div>
                            </div>
                    </div>
                </Collapse>
            </div>
        )
    }
}